angular.
module("dx.webapp.printing").
constant("DX_PAGE_BREAK",
	Object.freeze({
		NO_PAGE_BREAK: "no-page-break",
		PAGE_BREAK_TITLE: "page-break-title",
		PAGE_BREAK_STUDENT: "page-break-student",
		PAGE_BREAK_QUESTION: "page-break-question",
	})
);
